(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function reveal(scope) {
    var els = (scope || document).querySelectorAll('[data-cwk-reveal]:not(.is-in), [data-j-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !hasIO || root.classList.contains('shopify-design-mode')) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function play(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  // Videos only play while on screen; reduced-motion users get a still frame
  // (background videos) or native controls (film videos).
  function videos(scope) {
    var vids = (scope || document).querySelectorAll('video[data-cwk-autoplay]');
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
    });
    if (reduce) {
      vids.forEach(function (v) {
        v.pause();
        if (v.getAttribute('data-cwk-autoplay') !== 'background') v.controls = true;
      });
      return;
    }
    if (!hasIO) {
      vids.forEach(play);
      return;
    }
    var vo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) play(entry.target);
        else entry.target.pause();
      });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { vo.observe(v); });
  }

  function init(scope) {
    reveal(scope);
    videos(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
